<div class="overlay" role="dialog" aria-live="assertive" aria-modal="true">
  <div class="block-card">
    <p class="emoji" aria-hidden="true">😟</p>
    <p class="title">Dispositivo temporariamente bloqueado</p>
    <p class="description">
      Digite o codigo de 6 digitos enviado ao responsavel da unidade para liberar o totem.
    </p>

    <div class="pin-wrapper">
      <input
        #pinInput
        class="pin-input"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="6"
        [disabled]="validatingPin"
        [value]="pinControl.value || ''"
        (input)="onPinInput($event)"
        aria-label="Codigo de desbloqueio"
      />

      <div class="slots" [class.disabled]="validatingPin" aria-hidden="true" (click)="pinInput.focus()">
        <span *ngFor="let digit of pinDigits">{{ digit }}</span>
      </div>
    </div>

    <p class="error" *ngIf="validationError">{{ validationError }}</p>

    <button class="primary" [disabled]="!canSubmit" (click)="onSubmitPin()">
      {{ validatingPin ? 'Validando...' : 'Desbloquear dispositivo' }}
    </button>

    <button
      class="resend"
      [disabled]="resendLoading || resendCooldownSeconds > 0"
      (click)="onResendCode()"
    >
      {{ resendLoading ? 'Reenviando...' : resendLabel }}
    </button>
  </div>
</div>
